/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.23/esri/copyright.txt for details.
*/
import{c as s}from"../../../../chunks/mat3f32.js";import{TiledDisplayObject as r}from"./TiledDisplayObject.js";class t extends r{_createTransforms(){return{dvs:s(),tileMat3:s()}}}export{t as RenderableTile};
